// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-item-wise-sales-table-header{background-color:#fffce4;box-shadow:0 2px 2px 0 rgba(0,0,0,.04)}.report-item-wise-sales-table-header th{font-size:14px!important;font-weight:700!important}.report-item-wise-sales-table-header th.active{border-bottom:4px solid #ff8f5c!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
